import { render, staticRenderFns } from "./style-testing.vue?vue&type=template&id=e3034a4a&scoped=true"
import script from "./style-testing.vue?vue&type=script&lang=js"
export * from "./style-testing.vue?vue&type=script&lang=js"
import style0 from "./style-testing.vue?vue&type=style&index=0&id=e3034a4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3034a4a",
  null
  
)

export default component.exports